/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @param {RootState} state
 */
export function selectComposerMode (state) {
    return state.composer.mode;
}

/**
 * @param {RootState} state
 */
export function selectComposerContentOnly (state) {
    return state.composer.contentOnly;
}

/**
 * @param {RootState} state
 */
export function selectComposerEditMode (state) {
    return state.composer.mode === "edit";
}

/**
 * @param {RootState} state
 */
export function selectComposerLastComponentAdded (state) {
    return state.composer.lastComponentAdded;
}

/**
 * @param {RootState} state
 */
export function selectComposerSnackbarMessage (state) {
    return state.composer.snackbarMessage;
}

/**
 * @param {RootState} state
 */
export function selectComposerActiveFieldName (state) {
    return state.composer.activeFieldName;
}

/**
 * @param {RootState} state
 */
export function selectComposerFieldState (state) {
    return state.composer.fieldsState;
}

/**
 * @typedef {import('./composer.state').ComposerState} ComposerState
 */

/**
 * @typedef {object} RootState
 * @property {ComposerState} composer
 */
